import React from 'react';
import './GameBoard.css';

const Square = ({ value, onClick, isWinning, isClickable }) => {
  return (
    <button
      className={`square ${isWinning ? 'winning' : ''} ${!isClickable ? 'disabled' : ''}`}
      onClick={onClick}
      disabled={!isClickable}
    >
      <span className={`symbol ${value ? value.toLowerCase() : ''}`}>
        {value}
      </span>
    </button>
  );
};

const GameBoard = ({ board, onSquareClick, winningLine, isPlayerTurn }) => {
  const renderSquare = (index) => {
    const isWinning = winningLine && winningLine.includes(index);
    const isClickable = isPlayerTurn && board[index] === null;

    return (
      <Square
        key={index}
        value={board[index]}
        onClick={() => onSquareClick(index)}
        isWinning={isWinning}
        isClickable={isClickable}
      />
    );
  };

  return (
    <div className="game-board">
      <div className="board-grid">
        {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(renderSquare)}
      </div>
    </div>
  );
};

export default GameBoard;